import { render } from "./AppPostEmbed.html?vue&type=template&id=2f0bdeb2"
import script from "./AppPostEmbed.js?vue&type=script&lang=js"
export * from "./AppPostEmbed.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__